import React from 'react';
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'REJECTED', label: 'Rejected' },
  { value: 'CANCELLED', label: 'Cancelled' },
];

const RemoteOfficeHoursQuotaFilters = ({
  filters,
  setFilters,
  projects = [],
  showEmployeeFilter = false,
  employees = [],
}) => (
  <Box sx={{ mb: 3 }}>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={3}>
        <FormControl fullWidth size="small">
          <InputLabel>Status</InputLabel>
          <Select
            value={filters.status || ''}
            label="Status"
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, status: e.target.value }))
            }
          >
            {STATUS_OPTIONS.map((opt) => (
              <MenuItem key={opt.value || 'all'} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FormControl fullWidth size="small">
          <InputLabel>Project</InputLabel>
          <Select
            value={filters.projectId || ''}
            label="Project"
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, projectId: e.target.value }))
            }
          >
            <MenuItem value="">All</MenuItem>
            {projects.map((project) => (
              <MenuItem
                key={project.projectId || project.id}
                value={project.projectId || project.id}
              >
                {project.projectName || project.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Quota month"
            views={['year', 'month']}
            inputFormat="MMM YYYY"
            value={filters.quotaMonth ? dayjs(filters.quotaMonth) : null}
            onChange={(value) =>
              setFilters((prev) => ({
                ...prev,
                quotaMonth: value ? value.startOf('month').format('YYYY-MM-DD') : '',
              }))
            }
            renderInput={(params) => (
              <TextField {...params} fullWidth size="small" />
            )}
          />
        </LocalizationProvider>
      </Grid>
      {showEmployeeFilter && (
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Employee</InputLabel>
            <Select
              value={filters.empId || ''}
              label="Employee"
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, empId: e.target.value }))
              }
            >
              <MenuItem value="">All</MenuItem>
              {employees.map((emp) => (
                <MenuItem key={emp.id || emp.employeeId} value={emp.id || emp.employeeId}>
                  {emp.firstName
                    ? `${emp.firstName} ${emp.lastName || ''}`
                    : emp.employeeName || emp.id}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}
    </Grid>
  </Box>
);

export default RemoteOfficeHoursQuotaFilters;
